import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=152d0ce4&scoped=true&"
import script from "./tree.vue?vue&type=script&lang=ts&"
export * from "./tree.vue?vue&type=script&lang=ts&"
import style0 from "./tree.vue?vue&type=style&index=0&id=152d0ce4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152d0ce4",
  null
  
)

export default component.exports